/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Change_Detection_Complete_ToastInputs */

const en_scene_change_detection_complete_toast = /** @type {(inputs: Scene_Change_Detection_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scene Detection Complete`)
};

const fr_scene_change_detection_complete_toast = /** @type {(inputs: Scene_Change_Detection_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detection de scene terminee`)
};

const de_scene_change_detection_complete_toast = /** @type {(inputs: Scene_Change_Detection_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szenenerkennung abgeschlossen`)
};

const it_scene_change_detection_complete_toast = /** @type {(inputs: Scene_Change_Detection_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rilevamento scena completato`)
};

const ru_scene_change_detection_complete_toast = /** @type {(inputs: Scene_Change_Detection_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обнаружение сцены завершено.`)
};

const es_scene_change_detection_complete_toast = /** @type {(inputs: Scene_Change_Detection_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detección de escena completa`)
};

const zh_cn2_scene_change_detection_complete_toast = /** @type {(inputs: Scene_Change_Detection_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`场景检测完成`)
};

const ja_scene_change_detection_complete_toast = /** @type {(inputs: Scene_Change_Detection_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`シーン検出完了`)
};

const hi_scene_change_detection_complete_toast = /** @type {(inputs: Scene_Change_Detection_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दृश्य पहचान पूर्ण`)
};

const pt_pt2_scene_change_detection_complete_toast = /** @type {(inputs: Scene_Change_Detection_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detecção de cena concluída`)
};

/**
* | output |
* | --- |
* | "Scene Detection Complete" |
*
* @param {Scene_Change_Detection_Complete_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_change_detection_complete_toast = /** @type {((inputs?: Scene_Change_Detection_Complete_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Change_Detection_Complete_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_scene_change_detection_complete_toast(inputs)
	if (locale === "de") return de_scene_change_detection_complete_toast(inputs)
	if (locale === "it") return it_scene_change_detection_complete_toast(inputs)
	if (locale === "ru") return ru_scene_change_detection_complete_toast(inputs)
	if (locale === "es") return es_scene_change_detection_complete_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_scene_change_detection_complete_toast(inputs)
	if (locale === "ja") return ja_scene_change_detection_complete_toast(inputs)
	if (locale === "hi") return hi_scene_change_detection_complete_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_scene_change_detection_complete_toast(inputs)
	return en_scene_change_detection_complete_toast(inputs)
});